import { useContext, useMemo } from 'react'

import { OptimizelyContext } from '@optimizely/react-sdk'

import { getDiscountInfo } from '@features/scrollable-basket'

import { useIsBasketInGoustoAnytimeDiscountPopulation } from './useIsBasketInGoustoAnytimeDiscountPopulation'

const DISCOUNT_VISIBILITY_FLAG = 'tomatoes_ofx_discount_visibility_basket'

type DiscountTracking = {
  discountPercent: number
  discountApplied: boolean
}

export type BasketDiscountLabelState = {
  showLabel: boolean
  discountTracking?: DiscountTracking
}

export const useShowBasketDiscountLabel = (
  pricing: Parameters<typeof getDiscountInfo>[0],
): BasketDiscountLabelState => {
  const { optimizely } = useContext(OptimizelyContext)
  const isInPopulation = useIsBasketInGoustoAnytimeDiscountPopulation()
  const { discountPercent, discountApplied } = getDiscountInfo(pricing)
  const isEligible = isInPopulation && discountApplied

  // Decide only when eligible so the OFX_DECISION exposure isn't emitted for
  // no-discount baskets or non-population users. Memoised so re-renders don't re-emit.
  const enabled = useMemo(
    () => (optimizely && isEligible ? optimizely.decide(DISCOUNT_VISIBILITY_FLAG).enabled : false),
    [optimizely, isEligible],
  )

  return {
    showLabel: enabled,
    discountTracking: isInPopulation ? { discountPercent, discountApplied } : undefined,
  }
}
